/**
 * The Worker's `/health.features` flags, fetched once per page load and shared
 * by every "is this capability on?" question in the SPA (read-aloud,
 * dictation, audio-upload transcription). One round trip, one cache — a
 * failed fetch reads as "everything off".
 */
export interface HealthFeatures {
  tts?: boolean
  dictation?: boolean
  transcription?: boolean
  pdfExport?: boolean
  webPush?: boolean
  meetings?: boolean
}

let cached: Promise<HealthFeatures> | null = null

export function healthFeatures(): Promise<HealthFeatures> {
  cached ??= fetch('/health', { credentials: 'include' })
    .then((r) => r.json())
    .then((j: { features?: HealthFeatures }) => j.features ?? {})
    .catch(() => ({}))
  return cached
}

/** Whether the Worker can synthesize speech (a TTS provider resolved). */
export const ttsAvailable = (): Promise<boolean> => healthFeatures().then((f) => Boolean(f.tts))
/** Whether the Worker resolved a realtime STT provider. */
export const dictationAvailable = (): Promise<boolean> =>
  healthFeatures().then((f) => Boolean(f.dictation))
/** Whether uploaded audio/video will be transcribed (an async STT provider resolved). */
export const transcriptionAvailable = (): Promise<boolean> =>
  healthFeatures().then((f) => Boolean(f.transcription))
